import { storage } from "./storage";

const STORAGE_KEY = "guest_id";

/**
 * Get-or-create a stable per-browser guest id, persisted in localStorage.
 *
 * Sent as the `X-Guest-Id` header on anonymous file translations so the backend
 * can allow the first free translation and require login afterwards. It is a soft
 * signal (clearing storage resets it) — the server also enforces a per-IP daily
 * cap as a backstop.
 *
 * Returns null during SSR (no localStorage); the request then falls back to the
 * IP-only limit on the server.
 */
export function getGuestId(): string | null {
  if (typeof window === "undefined") return null;
  let id = storage.getItem(STORAGE_KEY);
  if (!id) {
    id =
      typeof crypto !== "undefined" && "randomUUID" in crypto
        ? crypto.randomUUID()
        : `g-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
    storage.setItem(STORAGE_KEY, id);
  }
  return id;
}
